<div class="form-wizard" *ngIf="negocio">
    <div class="form-wizard-header">
        <h2 class="form-wizard-title">
            {{getTitle()}}
        </h2>

        <button type="button" class="btn form-wizard-btn-close" title="Fechar" (click)="close()" *ngIf="isShowBtnClose">
            <i class="fas fa-times"></i>
        </button>
    </div>

    <div class="form-wizard-body">
        <sgt-negocio-form-insert-stepper
            #stepper
            (selectionChange)="onStepChange($event)"
            [linear]="true">

            <!-- Funil de Venda -->
            <cdk-step #stepFunil *ngIf="negocio.isShowFunilVenda">
                <sgt-negocio-form-insert-step-funil
                    #formFunil
                    [isFirstStep]="true"
                    [canEditFunilVenda]="negocio.canEditFunilVenda"
                    [tiposFunilVendaFasesFilter]="negocio.tiposFunilVendaFasesFilter"
                    [(funilVenda)]="negocio.funilVenda"
                    [(idFunilVenda)]="negocio.idFunilVenda"
                    [canEditFunilVendaFase]="negocio.canEditFunilVendaFase"
                    [(funilVendaFase)]="negocio.funilVendaFase"
                    [(idFunilVendaFase)]="negocio.idFunilVendaFase"
                    [(tipoFunilVendaFase)]="negocio.tipoFunilVendaFase"
                    (next)="nextStepFunilVenda()">
                </sgt-negocio-form-insert-step-funil>
            </cdk-step>            
        
            <!-- Lead -->
            <cdk-step #stepLead *ngIf="negocio.isFaseQualificacao() && negocio.isShowLead">
                <sgt-negocio-form-insert-step-lead
                    #formLead
                    [isFirstStep]="!negocio.isShowFunilVenda"
                    [(novoLead)]="negocio.novoLead"
                    [(idLead)]="negocio.idLead"
                    [(lead)]="negocio.lead"
                    (idUsuarioResponsavelChange)="negocio.idUsuarioResponsavel = $event"
                    (previus)="stepper.previous()"
                    (next)="stepper.next()"
                    (cancel)="close()">
                </sgt-negocio-form-insert-step-lead>
            </cdk-step>

            <!-- Cliente -->
            <cdk-step #stepCliente *ngIf="negocio.isFaseOportunidade() && negocio.isShowCliente">
                <sgt-negocio-form-insert-step-cliente
                    #formCliente
                    [isFirstStep]="!negocio.isShowFunilVenda"
                    [(idCliente)]="negocio.idCliente"
                    [(cliente)]="negocio.cliente"
                    (idUsuarioResponsavelChange)="negocio.idUsuarioResponsavel = $event"
                    (previus)="stepper.previous()"
                    (next)="stepper.next()">
                </sgt-negocio-form-insert-step-cliente>
            </cdk-step>            
            
            <!-- Negócio -->
            <cdk-step #stepNegocio>
                <sgt-negocio-form-insert-step-negocio
                    #formNegocio
                    [isFaseQualificacao]="negocio.isFaseQualificacao()"
                    [isFaseOportunidade]="negocio.isFaseOportunidade()"
                    [lead]="negocio.lead"
                    [cliente]="negocio.cliente"
                    [(idUsuarioResponsavel)]="negocio.idUsuarioResponsavel"
                    [(usuarioResponsavel)]="negocio.usuarioResponsavel"
                    [(prioridade)]="negocio.prioridade"
                    [(dataPrevisaoFechamento)]="negocio.dataPrevisaoFechamento"
                    [(valor)]="negocio.valor"
                    [(idCampanha)]="negocio.idCampanha"
                    [isCreating]="isCreating"
                    [btnCreateText]="getBtnCreateText()"
                    [btnCreatingText]="getBtnCreatingText()"
                    (previus)="stepper.previous()"
                    (next)="create()">
        
                </sgt-negocio-form-insert-step-negocio>
            </cdk-step>           
        </sgt-negocio-form-insert-stepper>
    </div>
</div>
